
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"19","height":"19","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#399E8B","d":"M9.526.315c5.08 0 9.2 4.12 9.2 9.2a9.198 9.198 0 0 1-9.2 9.199 9.199 9.199 0 0 1-9.2-9.2c0-5.078 4.118-9.2 9.2-9.2z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M9.526 13.997a.9.9 0 0 1-.637-.264L3.836 8.68a.899.899 0 0 1 0-1.274.9.9 0 0 1 1.273 0l4.416 4.415 4.414-4.415a.9.9 0 0 1 1.273 0 .899.899 0 0 1 0 1.274l-5.05 5.052a.89.89 0 0 1-.636.264z"}})])
      }
    
      }
    